import clsx from 'clsx'

import { useDialogBottomSheet } from 'shared/ui/dialog-bottom-sheet/lib'
import { Paper } from 'shared/ui/paper'

import { IPhoneCountry } from '../../phone-input'

import s from './styles.module.scss'

interface Props {
  setCurrentPhoneMask: (value: IPhoneCountry) => void
  localeCountries: IPhoneCountry[]
  currentCountry: IPhoneCountry | undefined
}

export const SelectCountrySheet = ({
  setCurrentPhoneMask,
  localeCountries,
  currentCountry,
}: Props) => {
  const { closeDialog } = useDialogBottomSheet()

  const onSelectCountry = (item: IPhoneCountry) => {
    closeDialog()
    setCurrentPhoneMask(item)
  }

  return (
    <div className={s.countrySheet}>
      {currentCountry && (
        <div className={s.currentCountryCard}>
          <img
            src={currentCountry.flag}
            className={s.flag}
            alt=""
          />

          <div className={s.textContainer}>
            <h3 className={s.country}>{currentCountry.name}</h3>
            <p className={s.code}>{currentCountry.dial_code}</p>
          </div>
        </div>
      )}

      <div className={s.countryList}>
        <Paper padding={[0]}>
          <div className={s.wrapperOptions}>
            {localeCountries
              .filter((country) => country.code !== currentCountry?.code)
              .map((item, index) => (
                <div
                  key={'option' + item.name + index}
                  className={clsx(s.option)}
                  onClick={() => onSelectCountry(item)}
                >
                  <img
                    src={item.flag}
                    className={s.flag}
                    alt=""
                  />

                  <div className={s.textContainer}>
                    <h3 className={s.country}>{item.name}</h3>
                    <p className={s.code}>{item.dial_code}</p>
                  </div>
                </div>
              ))}
          </div>
        </Paper>
      </div>
    </div>
  )
}
